export default __webpack_public_path__ + "static/media/logo.279e2df5.svg";